import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import AppMUIAutocomplete from '../../../../components/common/AppMUIAutoComplete';
import {
  FormQuestion,
  FormQuestionOption,
} from '../../../../services/operations/forms';

type Props = {
  question: FormQuestion;
  value: string | null;
  onChange: (value: string | null) => void;
};

function PublicDropdown({question, value, onChange}: Props) {
  const {t} = useTranslation();

  const options = useMemo(
    () => question?.options?.filter(option => !option?.isOther) ?? [],
    [question?.options],
  );

  const selectedOption =
    options.find(option => (option._id ?? option.key) === value) ?? null;

  return (
    <div className="flex flex-col gap-3 mt-3">
      <div className="max-w-[567px]">
        <AppMUIAutocomplete<FormQuestionOption>
          size="small"
          fullWidth
          options={options}
          value={selectedOption}
          placeholder={t('forms.public.dropdownPlaceholder')}
          getOptionLabel={option => option?.label ?? ''}
          isOptionEqualToValue={(option, selected) =>
            (option._id ?? option.key) === (selected._id ?? selected.key)
          }
          onChange={(_, newValue) =>
            onChange(newValue?._id ?? newValue?.key ?? null)
          }
        />
      </div>

      <div className="flex">
        <button
          type="button"
          onClick={() => onChange(null)}
          className="text-linkBlue underline hover:opacity-80 transition-opacity">
          {t('forms.public.clearSelection')}
        </button>
      </div>
    </div>
  );
}

export default PublicDropdown;
